import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CORE_API_URL } from '../../app.constants';

import { Group } from './group.model';
import { createRequestOption } from '../../shared';

type EntityResponseType = HttpResponse<Group>;
type EntityArrayResponseType = HttpResponse<Group[]>;

@Injectable()
export class GroupService {

    private resourceUrl =  CORE_API_URL + '/v1/groups';

    constructor(private http: HttpClient) { }

    create(group: Group): Observable<EntityResponseType> {
        const copy = this.convert(group);
        return this.http.post(this.resourceUrl, copy, { observe: 'response' });
    }

    update(group: Group): Observable<EntityResponseType> {
        const copy = this.convert(group);
        return this.http.put(this.resourceUrl, copy, { observe: 'response' });
    }

    find(id: number): Observable<EntityResponseType> {
        return this.http.get<Group>(`${this.resourceUrl}/${id}`, { observe: 'response' });
    }

    query(req?: any): Observable<EntityArrayResponseType> {
        const options = createRequestOption(req);
        return this.http.get<Group[]>(this.resourceUrl, { params: options, observe: 'response' });
    }

    delete(id: number): Observable<Object> {
        return this.http.delete(`${this.resourceUrl}/${id}`);
    }

    /**
     * Convert a Group to a JSON which can be sent to the server.
     */
    private convert(group: Group): Group {
        const copy: Group = Object.assign({}, group);
        return copy;
    }
}
